import React from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import { NineCellLoading } from 'react-loadingg';
import translateString from "../../../utils/Locales";
import getAllFattureElettroniche from "../../../services/getAllFattureElettroniche";
import moment from "moment";
import getACubePDF from "../../../services/getACubePDF";
import { TailSpin } from 'react-loader-spinner';
import getClient from "../../../services/getClient";


let t = translateString;

export default class ElectronicReceipts extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
        isLoading: true 
    };

  }

  async componentDidMount(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    
    this.cliente = await getClient('', '', cookies.get('db', { path: '/' }));

    if (this.cliente.fatturazione_attiva === '1') {
      this.ricevute = await getAllFattureElettroniche(username, token);
    }

    this.setState({ isLoading: false });
  }

  async getPdf(uuid) {

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    let res = await getACubePDF(username, token, uuid);
    if (res) {
      window.open(res, '_blank');
      this.setState({ getting: undefined });
    }
  }

  render () {

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />
    if (this.cliente.fatturazione_attiva === '0') return (
        <div style={{ height: '80%', width: '100%', display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
            <img src={ require('../../../images/locked.png') } style={{ width: 200, height: 200, opacity: 0.5 }} />
            <p style={{ color: 'darkgrey', fontSize: 16, fontWeight: 'bold', textAlign: 'center', marginLeft: 40, marginRight: 40 }}>{this.cliente.type === '0' ? t('ris_premium') : t('attiva_fatt')}</p>
        </div>
    );

    return (
      <div id={Math.random()}>
        <PageTitle title={t('fatt_elettr')} />

        <div>
        { (!this.ricevute || this.ricevute.length === 0) &&
           <div style={{ marginTop: 100, display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
              <img src={ require('../../../images/nothing.png') } style={{ width: 200, height: 200, opacity: 0.5 }} />
              <p style={{ color: 'darkgrey', fontSize: 16, fontWeight: 'bold', textAlign: 'center', marginLeft: 40, marginRight: 40 }}>{t('no_dati')}</p>
          </div>
        }
        {
          this.ricevute.map ((ricevuta, ind) => {

            let date = moment(ricevuta.created_at, 'yyyy-MM-DDTHH:mm:ss.SSSz').format('DD/MM/yyyy');
            let payload = JSON.parse(ricevuta.payload);

            return <div style={rataDiv} key={Math.random()} >
              <section>
                  <div style={textDiv}><b>{t('numero')}</b>: {payload.fattura_elettronica_body[0].dati_generali.dati_generali_documento.numero}</div>
                  <div style={textDiv}><b>{t('data')}</b>: {date}</div>
                  <div style={textDiv}><b>{t('importo')}</b>: € {payload.fattura_elettronica_body[0].dati_pagamento[0].dettaglio_pagamento[0].importo_pagamento}</div>
                  <div style={textDiv}><b>{t('studente_m')}</b>: {ricevuta.recipient.surname} {ricevuta.recipient.name} ({ricevuta.recipient.business_fiscal_code})</div>
                  <div style={{ ...textDiv, color: 'lightgrey' }}>Conservatazione sostitutiva secondo termini di legge a carico di A-Cube (id: ...)</div>
              </section>
              <section style={{ marginRight: 40 }}>
                { this.state.getting !== ind && <img src={ require('../../../images/pdf_bill.png') } style={{ height: 30, width: 30, cursor: 'pointer' }} onClick={() => { this.setState({ getting: ind }); this.getPdf(ricevuta.uuid); }} /> }
                { this.state.getting === ind && <TailSpin ariaLabel="loading-indicator" wrapperStyle={{ width: 30, height: 30, marginTop: -40 }} color={'#db4655'} /> }
              </section>
            </div>
          })
        }

        </div>
      </div>
    );
  }
}

const rataDiv = {
  borderRadius: '10px',
  padding: '10px',
  paddingLeft: 20, 
  paddingTop: 20, 
  paddingBottom: 20, 
  display: 'flex', 
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 10,
  boxShadow: '0px 2px 10px lightgrey',
}

const textDiv = {
  marginLeft: 20,
}